import AppStorePng from '../../assets/img/app_store.png';
import MaskGroup81x from '../../assets/img/mask-group-8@1x.png';
import Polygon121x from '../../assets/img/polygon-1-2@1x.png';
import Line411x from '../../assets/img/line-4-1@1x.png';
import Path711x from '../../assets/img/path-7-1@1x.png';
import Polygon1101x from '../../assets/img/polygon-1-10@1x.png';

import './index.css';
import './responsive.css';



const scrollUp = () => {
  var element = document.querySelector('.x3-d_-feature_-block-JUZYnQ');
  var rOffset =  element.getBoundingClientRect().top;
  window.scrollTo({top: rOffset , left: 0, behavior: 'smooth' });
}

function FeaturesSection() {
  return (
    <div className="x3-d_-feature_-block-JUZYnQ" >
    <span className="scrollHandle" onClick={() => { scrollUp(); }}></span>
      <div className="x3-d_-gradient_-box-2Woxbx">
        <div className="gradient_-box1-FZ2WNs"></div>
      </div>

      <img className="mask-group-8-2Woxbx" src={MaskGroup81x} />

      <div className="group-1223-2Woxbx">
        <div className="cube-icon">
          <div className="ico_3-d-Ruu7Pf">
            <img className="polygon-1-LHyOvf" src={Polygon121x} />
            <img className="line-4-LHyOvf" src={Line411x} />
            <img className="path-7-LHyOvf" src={Path711x} />
          </div>
        </div>

        <div className="see-insidemulti-laye-Ruu7Pf titles">
          See inside<br />multi-layered <br />models with <span className="bold-title">full 3D</span>
        </div>

        <div className="zoom-pan-expand-tilt-Ruu7Pf bullets">
          Zoom. Pan. Expand. Tilt. Animate. Highlight. <br />
          Showcase products or solutions in action on any screen.
        </div>

        <div className="bullets-download-button">
          <div className="use-interactive-capa-Ruu7Pf">
            <div className="bullet-row bullets">
              <div className="bullet-wrapper">
                <div className="bullet_-icon">
                  <img className="polygon-1-0axxLo" src={Polygon1101x} />
                </div>
              </div>

              <p>Use interactive capabilities to engage, inform, and stand out from the competition</p>
            </div>

            <div className="bullet-row bullets">
              <div className="bullet-wrapper">
                <div className="bullet_-icon">
                  <img className="polygon-1-0axxLo" src={Polygon1101x} />
                </div>
              </div>

              <p>Guide prospects seamlessly through intuitive features and technical details</p>
            </div>

            <div className="bullet-row bullets">
              <div className="bullet-wrapper">
                <div className="bullet_-icon">
                  <img className="polygon-1-0axxLo" src={Polygon1101x} />
                </div>
              </div>

              <p>Transition to detailed views of product exteriors</p>
            </div>
          </div>

          <div onClick={() => { window.open("https://apps.apple.com/us/app/demo-presentationos/id1607998050", '_blank');}}  className="app_-store-2Woxbx">
            <img className="download-app-store" src={AppStorePng} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturesSection;